/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ExportAsGaebMutationVariables = Types.Exact<{
  input: Types.ExportAsGaebInput;
}>;


export type ExportAsGaebMutation = { exportAsGaeb: { __typename: 'ExportAsGaebResult', downloadUrl: string, filename: string } };


export const ExportAsGaebDocument = gql`
    mutation ExportAsGaeb($input: ExportAsGaebInput!) {
  exportAsGaeb(input: $input) {
    downloadUrl
    filename
  }
}
    `;
export type ExportAsGaebMutationFn = Apollo.MutationFunction<ExportAsGaebMutation, ExportAsGaebMutationVariables>;

/**
 * __useExportAsGaebMutation__
 *
 * To run a mutation, you first call `useExportAsGaebMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAsGaebMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAsGaebMutation, { data, loading, error }] = useExportAsGaebMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportAsGaebMutation(baseOptions?: Apollo.MutationHookOptions<ExportAsGaebMutation, ExportAsGaebMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportAsGaebMutation, ExportAsGaebMutationVariables>(ExportAsGaebDocument, options);
      }
export type ExportAsGaebMutationHookResult = ReturnType<typeof useExportAsGaebMutation>;
export type ExportAsGaebMutationResult = Apollo.MutationResult<ExportAsGaebMutation>;
export type ExportAsGaebMutationOptions = Apollo.BaseMutationOptions<ExportAsGaebMutation, ExportAsGaebMutationVariables>;